import React, { useEffect, useState } from "react";
import Gear from "../Gear/Gear";
import "./Gears.css";

const Gears = () => {
  const [Gears, setGears] = useState([]);
  useEffect(() => {
    fetch("https://rocky-headland-86504.herokuapp.com/service")
      .then((res) => res.json())
      .then((data) => setGears(data));
  }, []);

  return (
    <div>
      <div className="gears-section">
        {Gears.map((gear) => (
          <Gear key={gear._id} gear={gear}></Gear>
        ))}
      </div>
    </div>
  );
};

export default Gears;
